import React from "react";
import ReactECharts from "echarts-for-react";

const HistoryChart = ({ xData, yData }) => {
  const options = {
    grid: { top: 8, right: 8, bottom: 24, left: 36, width: "100%" },
    xAxis: {
      type: "category",
      data: xData,
      splitArea: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: function (value, index) {
          if (value.toString().length > 6) {
            return parseFloat((value / 1e6).toFixed(2)) + " M";
          } else return value;
        },
      },
    },
    series: [
      {
        data: yData,
        type: "line",
        smooth: false,
        lineStyle: { color: "#000", width: 5, type: "solid" },
      },
    ],
    tooltip: {
      trigger: "axis",
    },
  };

  return <ReactECharts option={options} />;
};

export default HistoryChart;
